import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {StockTakeSessionExtensionModel} from '../../../../../../models/aggregates/erp/stock';
import {Core2Config} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class StocktakeExtService extends BaseApiTemplateService<StockTakeSessionExtensionModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-ext';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-ext';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-ext';
    this.httpClient = http;
  }

}
